// The store's own aggregator: the period's games and how many are scanned,
// for the dashboard header's caption and the cards' coverage notes.
import { aggregatorId, type Accumulator, type Aggregator, type PeriodContext, type PeriodSummary } from '@chess/api-model';

export class PeriodAggregator implements Aggregator<PeriodSummary> {
  readonly id = aggregatorId('store.period');

  start(context: PeriodContext): Accumulator<PeriodSummary> {
    const summary: PeriodSummary = { from: context.from, to: context.to, games: 0, scanned: 0 };
    return {
      add: (game) => {
        summary.games += 1;
        if (game.scanned) summary.scanned += 1;
      },
      result: () => ({ ...summary }),
    };
  }
}
